import { useSearchParams } from 'react-router-dom';
import { HeadingPages } from '../../../components/HeadingPages';
import { Box, Flex, Text } from '@chakra-ui/react';
import { TextoCategoria, TextoHome, TextoProduto, TextoUltraRapido } from './Options';
import { Menu } from './Menu';
import { TextoSegmento } from './Options/TextoSegmento';
import { useEffect } from 'react';
import { Categoria } from './AlterarTitulo/Categoria';
import { Segmento } from './AlterarTitulo/Segmento';
import { TagCategoria } from './AlterarTag/TagCategoria';
import { TagSegmento } from './AlterarTag/TagSegmento';

export function TextoSeoSite() {
  const [searchParams, setSearchParams] = useSearchParams();
  const textoHome = searchParams.get('textoSeo') === 'home';
  const textoProduto = searchParams.get('textoSeo') === 'produto';
  const textoCategoria = searchParams.get('textoSeo') === 'categoria';
  const textoSegmento = searchParams.get('textoSeo') === 'segmento';
  const textoUltraRapido = searchParams.get('textoSeo') === 'ultra-rapido';

  const conditionalRender = {
    home: <TextoHome />,
    categoria: <TextoCategoria />,
    produto: <TextoProduto />,
    segmento: <TextoSegmento />,
    'ultra-rapido': <TextoUltraRapido />
  };

  useEffect(() => {
    if (searchParams.get('textoSeo') === null) {
      setSearchParams({ textoSeo: 'home' });
    }
  }, [searchParams]);

  return (
    <>
      <HeadingPages name="Alterar Texto SEO do Site" />

      <Box maxW="1200px" mx="auto" mt="20px" display="flex" flexDirection="column" gap={4} w="100%">
        <Flex
          flexDir="column"
          gap={4}
          sx={{
            borderBottom: '1px solid #d4d4d4',
            paddingBottom: '20px'
          }}>
          <Text fontSize="2xl" fontWeight="bold">
            Alterar Títulos do Site
          </Text>
          <Flex gap={4}>
            <Categoria />
            <Segmento />
          </Flex>
        </Flex>

        <Flex
          flexDir="column"
          gap={4}
          sx={{
            borderBottom: '1px solid #d4d4d4',
            paddingBottom: '20px'
          }}>
          <Text fontSize="2xl" fontWeight="bold">
            Alterar Tags
          </Text>
          <Flex gap={4}>
            <TagCategoria />
            <TagSegmento />
          </Flex>
        </Flex>

        <Text fontSize="2xl" fontWeight="bold">
          Alterar Textos SEO do Site
        </Text>

        <Menu
          textoCategoria={textoCategoria}
          textoHome={textoHome}
          textoProduto={textoProduto}
          textoSegmento={textoSegmento}
          textoUltraRapido={textoUltraRapido}
        />

        {conditionalRender[searchParams.get('textoSeo')]}
      </Box>
    </>
  );
}
